import React__default, { useEffect } from 'react';
import { v4 } from 'uuid';
import { SearchContextProvider, useSearchContext } from './searchContext/SearchContextProvider.js';
import { ANALYTICS_WRAPPER_CLASS } from './util/analyticsConstants.js';
import { getUrlPrefix } from './util/secondaryLanguageUrlPrefix.js';

var ExternalClickTracker = function ExternalClickTracker(_ref) {
  var application = _ref.application;
  var _useSearchContext = useSearchContext(),
    query = _useSearchContext.query;
  useEffect(function () {
    var externalClickTracker = function externalClickTracker(evt) {
      var _evt$target$closest;
      var anchor = evt.target.closest('a');
      var searchApplication = (_evt$target$closest = evt.target.closest(".".concat(ANALYTICS_WRAPPER_CLASS))) === null || _evt$target$closest === void 0 ? void 0 : _evt$target$closest.dataset.searchApplicationName;
      var notSearchLink = searchApplication !== application || !evt.target.closest(".".concat(ANALYTICS_WRAPPER_CLASS)); //Unlikely to hit this case, but there might be links in the app not considered results
      if (!!anchor && notSearchLink) {
        var _anchor$attributes$hr;
        window.tracking.track('Search Application Non-Result Clicked', {
          application: application,
          destination: (_anchor$attributes$hr = anchor.attributes.href) === null || _anchor$attributes$hr === void 0 ? void 0 : _anchor$attributes$hr.nodeValue,
          query: query
        });
      }
    };
    document.addEventListener('click', externalClickTracker);
    return function () {
      document.removeEventListener('click', externalClickTracker);
    };
  }, [query]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
};
var SearchApplication = function SearchApplication(_ref2) {
  var children = _ref2.children,
    locale = _ref2.locale,
    _ref2$minCharLength = _ref2.minCharLength,
    minCharLength = _ref2$minCharLength === void 0 ? 1 : _ref2$minCharLength,
    _ref2$defaultToAwaiti = _ref2.defaultToAwaitingResults,
    defaultToAwaitingResults = _ref2$defaultToAwaiti === void 0 ? false : _ref2$defaultToAwaiti,
    _ref2$resultsPageUrl = _ref2.resultsPageUrl,
    resultsPageUrl = _ref2$resultsPageUrl === void 0 ? "".concat(getUrlPrefix(locale), "/search") : _ref2$resultsPageUrl,
    getResultsPageUrl = _ref2.getResultsPageUrl,
    queryString = _ref2.queryString,
    _ref2$applicationName = _ref2.applicationName,
    applicationName = _ref2$applicationName === void 0 ? 'SearchResults' : _ref2$applicationName,
    _ref2$trackExternalCl = _ref2.trackExternalClicks,
    trackExternalClicks = _ref2$trackExternalCl === void 0 ? false : _ref2$trackExternalCl,
    _ref2$resultPlugins = _ref2.resultPlugins,
    resultPlugins = _ref2$resultPlugins === void 0 ? [] : _ref2$resultPlugins,
    _ref2$instanceId = _ref2.instanceId,
    instanceId = _ref2$instanceId === void 0 ? v4() : _ref2$instanceId,
    resultDisplayConfiguration = _ref2.resultDisplayConfiguration,
    enabledAbTests = _ref2.enabledAbTests,
    auth = _ref2.auth,
    waitOnTestLoad = _ref2.waitOnTestLoad,
    logger = _ref2.logger;
  return /*#__PURE__*/React__default.createElement(SearchContextProvider, {
    minCharLength: minCharLength,
    defaultToAwaitingResults: defaultToAwaitingResults,
    locale: locale,
    resultsPageUrl: resultsPageUrl,
    getResultsPageUrl: getResultsPageUrl,
    queryString: queryString,
    resultPlugins: resultPlugins,
    instanceId: instanceId,
    resultDisplayConfiguration: resultDisplayConfiguration,
    applicationName: applicationName,
    enabledAbTests: enabledAbTests,
    auth: auth,
    waitOnTestLoad: waitOnTestLoad,
    logger: logger
  }, trackExternalClicks && /*#__PURE__*/React__default.createElement(ExternalClickTracker, {
    application: applicationName
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "search-application ".concat(ANALYTICS_WRAPPER_CLASS),
    "data-search-application-name": applicationName
  }, children));
};

export { SearchApplication as default };
//# sourceMappingURL=SearchApplication.js.map
